module.exports = __webpack_public_path__ + "static/img/2.269e6b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carouseImg/2.png
// module id = Mggw
// module chunks = 0